import { useRef } from 'react';
import styles from './PageTabs.module.css'

export default function PageTabs({
  id,
  tabs,
  current,
  onChange,
  label = 'Page views',
}) {
  const buttons = useRef([]);

  function handleKeyDown(event, index) {
    let nextIndex;

    switch(event.key) {
      case 'ArrowRight':
        nextIndex = (index + 1) % tabs.length;
        break;
      
      case 'ArrowLeft':
        nextIndex = (index - 1 + tabs.length) % tabs.length;
        break;
      
      case 'Home':
        nextIndex = 0;
        break;
      
      case 'End':
        nextIndex = tabs.length - 1;
        break;
      
      default:
        return;
    }

    event.preventDefault();

    const nextTab = tabs[nextIndex];

    if (nextTab.id !== current) {
      onChange(nextTab.id);
    }

    buttons.current[nextIndex]?.focus();
  }

  return (
    <div
    className={styles.tabs}
    role="tablist"
    aria-label={label}
    >
      {tabs.map((tab, index) => {
        const selected = tab.id === current;

        return (
          <button
          key={tab.id}
          ref={element => {
            buttons.current[index] = element;
          }}
          id={`${id}-tab-${tab.id}`}
          type="button"
          role="tab"
          aria-selected={selected}
          aria-controls={`${id}-panel-${tab.id}`}
          tabIndex={selected ? 0 : -1}
          className={styles.tab}
          onClick={() => {
            if (!selected) onChange(tab.id);
          }}
          onKeyDown={event => handleKeyDown(event, index)}
          >
            {tab.label}

            {tab.count !== undefined && tab.count !== null && (
              <span className={styles.count}>
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}